export default "__VITE_ASSET__DHoFyWeA__"